const INVITATION_STORAGE_KEYS = [
    "pending_invitation_slug",
    "pending_charity_id",
    "pending_back_qs",
    "pending_exclusive",
    "pending_venue_slug",
    "pending_entry_source"
]

function storageValue(storage, key) {
    try {
        return storage?.getItem(key) || ""
    } catch (_error) {
        return ""
    }
}

function sameOriginPath(value, location) {
    if (!value || !location?.origin) return ""

    try {
        const url = new URL(value, location.origin)
        if (url.origin !== location.origin) return ""
        return `${url.pathname}${url.search}${url.hash}`
    } catch (_error) {
        return ""
    }
}

export function pendingAuthContinuation({ storage = window.sessionStorage, location = window.location } = {}) {
    const slug = storageValue(storage, "pending_invitation_slug")

    if (slug) {
        const params = new URLSearchParams({ invitation: slug })
        const charityId = storageValue(storage, "pending_charity_id")
        const backQuery = storageValue(storage, "pending_back_qs")
        const exclusive = storageValue(storage, "pending_exclusive")
        const venue = storageValue(storage, "pending_venue_slug")
        const entrySource = storageValue(storage, "pending_entry_source")

        if (charityId) params.set("charity_id", charityId)
        if (exclusive === "true") params.set("exclusive", "true")
        if (backQuery) params.set("back_qs", backQuery)
        if (venue) params.set("venue", venue)
        if (entrySource) params.set("entry_source", entrySource)

        return `/party/editor?${params.toString()}`
    }

    if (storageValue(storage, "pending_ai_invitation") === "1") {
        return sameOriginPath(storageValue(storage, "pending_ai_return_to"), location)
    }

    return ""
}

export function applyPendingAuthContinuation(form, options = {}) {
    if (!form) return ""

    const destination = pendingAuthContinuation(options)
    let hidden = form.querySelector('input[name="continue_to"]')

    if (!hidden) {
        hidden = (form.ownerDocument || document).createElement("input")
        hidden.type = "hidden"
        hidden.name = "continue_to"
        form.appendChild(hidden)
    }

    // A server-provided continuation (notably an opaque guest-draft claim URL)
    // is authoritative. Session storage is only a fallback for older modal
    // entry points that do not already carry a destination.
    if (destination && !hidden.value) hidden.value = destination
    return hidden.value || ""
}

// OmniAuth preserves query parameters across the provider round trip, not POST
// fields. Keep POST/CSRF protection while also carrying modal fallback intent.
export function applySocialAuthContinuation(form, options = {}) {
    const destination = applyPendingAuthContinuation(form, options)
    const location = options.location || window.location
    const safeDestination = sameOriginPath(destination, location)
    const action = new URL(form.action, location.origin)
    if (action.origin !== location.origin) return ""

    if (safeDestination) action.searchParams.set("continue_to", safeDestination)
    else action.searchParams.delete("continue_to")
    form.action = action.toString()
    return safeDestination
}

export function clearPendingInvitationContinuation(storage = window.sessionStorage) {
    for (const key of INVITATION_STORAGE_KEYS) {
        try {
            storage?.removeItem(key)
        } catch (_error) {
            // Storage can be disabled. There is nothing else to clean up.
        }
    }
}
